import StripeModal from '../commons/StripeModal';

window.ExtPeople = {
	
	init : function(){

		// people form
		var target = $("#extPeopleForm").attr('action');
		var options = {
			success:function(data){
				ExtPeople.recordCallBack(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("extPeopleForm", target, options);
		$("#extPeopleForm").removeAttr('action');

		MyFacture.customForm();
	},
	
	recordCallBack: function(data){
		
		var formIsOk = MyForm.processJson(data, "prefsForm");
		if(formIsOk){
				Utils.reload();
		} else {
			if(data.form.msg){
				MyWindow.alert(data.form.msg, {type: 'error'});
			} else {
				MyWindow.alert(Loc.g('Une erreur est survenue !'), {type: 'error'});
			}
		}

	},

	deleteCardRequest : function(cardId, customerId){
		MyWindow.alert(Loc.g("Voulez-vous supprimer votre carte bancaire enregistrée ?"),{
			buttons : [
				{
					text : Loc.g("Non"),
					'class': 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					'class': 'btn btn-primary',
					click : function(){
						
						MyFacture.post("/rest/stripe/card/delete",{cardId : cardId, customerId : customerId}, function(data, result){
							Utils.reload();
						}, 'json', undefined, false);

					}
				}
			]
		});
	},

	updateCampaignInscription: _.debounce(function () {
		var subscribe = '';
		var unsubscribe = '';
		
		$('input[name=campaign]').each(function () {
			if (this.checked) {
				subscribe += $(this).attr('value').concat(',');
			} else {
				unsubscribe += $(this).attr('value').concat(',');
			}
		});

		$('#confirmCampaign').hide();

		$.ajax({
			url: '/?_f=extProfile',
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'updateCampaignInscription',
				unsubscribe: unsubscribe,
				subscribe: subscribe
			},
			success: function (data) {
				$('#inscriptions').hide();
				$('#inscriptionCampaignValidate').show();
			}
		});
	}, 200),


	
};